<template>
  <div class='payment'>
    <div class="head">
      <img v-if="token" class="imgAvatar" :src="Headportrait" width="64px" height="64px" />
      <div style="margin-left: 16px">
        <div v-if="token" style="display:flex;justify-content: space-between;width: 740px">
          <div style="display: flex">
            <div>{{name}}</div>
            <div  v-if="phone" style="font-size: 14px;margin-left: 2px">({{phone}})</div>
          </div>
          <div class="code-btn" @click="handleOpenCode">激活码兑换</div>
        </div>
        <div style="text-align: left;font-size: 14px;margin-top:10px">{{token?level==1?'体验会员':level==2?'VIP会员':level==3?'SVIP会员':'未开通':'未登录'}}</div>
        <div style="text-align: left;font-size: 14px;margin-top:10px" class="validity" v-if="level>=1&&endTime">到期时间：{{endTime}}</div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="left-head">
          <div v-if="level==0||!token" :class="type==='1'?'selected-head':'noselect-head'" @click="( )=>handleSelectType(1)">体验会员</div>
          <div v-if="Number(level)<=2||!token" :class="type==='2'?Number(level)!==0?'two-selected-new':'two-selected':'noselect-head'" @click="( )=>handleSelectType(2)">Kepler VIP会员</div>
          <div :class="type==='3'?Number(level)!==0&&Number(level)!==3?'three-selected-new':Number(level)>=2?'two-selected-new':'three-selected':'noselect-head'"
               @click="( )=>handleSelectType(3)">Kepler SVIP会员</div>
        </div>
        <Method :type="type" :isActive="true" @cancel="handleClose"/>
      </div>
      <div class="right">
        <div class="right-title">{{equityData[type].title}}</div>
        <div class="right-sub">核心权益</div>
        <div style="height: 370px">
          <div :class="type==2?'right-item':'three-item'" v-for="(item,index) in equityData[type].content">
            <span class="circle"></span>
            <span class="item-name">{{item}}</span>
          </div>
        </div>

        <el-button @click="$emit('cancel')" class="more-btn">查看更多权益 ＞ </el-button>
        <div class="right-text">不支持7天无理由退款</div>
      </div>
    </div>
    <UseCode :dialogFormVisible="dialogFormVisible" @cancel="dialogFormVisible=false"/>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { Accesstoimage } from "@/api/projectSquare/xmgc";
import Payment from './payment'
import Method from './method'

import outsourcerImg from '../../../assets/image/newjiebao.png';
import awardingImg from '../../../assets/image/newfabao.png'
import UseCode from './use-code'

export default {
  components:{Payment,Method,UseCode},
  props:{
    dialogVisible:Boolean,
    list:Array
  },
  data(){
    return{
      dialogFormVisible:false,
      selected:0,
      checked:false,
      isSelect:'',
      price:'',
      Headportrait: "",
      name:sessionStorage.getItem('userName'),
      phone:sessionStorage.getItem('Mobilephone'),
      level:sessionStorage.getItem('level'),
      endTime:sessionStorage.getItem('endTime'),
      type:'1',
      token:getToken(),
      equityData:{
        '1':{
          title:'体验会员',
          content:['创建应用数量1个','使用Kepler全部功能','软件应用可预览','建模工程师认证权限','接包、发包权限']
        },
        '2':{
          title:'Kepler VIP',
          content:['应用构建数量3个','支持标准部署架构','源代码下载权限','JAR组件导出功能','官方技术响应集群','5×12小时在线答疑']
        },
        '3':{
          title:'Kepler SVIP',
          content:['应用创建数量无上限','企业级部署方案','源代码下载权限','商用模板库无限调用',
            '应用分享与复制特权','JAR组件导出功能','服务器部署配额2次/年','专家远程支持1次/年','7×24小时紧急技术支持 ','VIP专属服务通道']
        }
      }
    }
  },
  created() {
    // this.isSelect=this.list[0].id
    // this.price=this.list[0].buyPrice;
    if(this.token){
      this.Whetherthelogin()
    }
    console.log(this.$route,'222222222')
    this.token=this.$route.query.token
    this.type=this.level==0?'1':Number(this.level)>=2?'3':'2'
    if(this.$route.query.token){
      sessionStorage.setItem('token',this.$route.query.token)
      sessionStorage.setItem("is_login", "true");
      this.url=this.$route.query.url
      this.$emit('header', false)
      // setTimeout(()=>{
      // console.log(sessionStorage.getItem('token'),'sessionStorage')

      // },9000)
    }else{
      this.url=window.location.origin+'/paymentSuccess.html'
    }
  },
  methods:{
    handleOpenCode(){
      this.dialogFormVisible=true
    },
    Whetherthelogin() {
      Accesstoimage().then(response => {
        this.Headportrait = this.ifimgsrc(
          response.headStatus,
          response.headportrait,
          response.loginType
        );
      }).catch(response => {});
    },

    // idp // 当前身份
    ifimgsrc(type, src, idp) {
      let imgsrc = "";
      if (type == 1) {
        imgsrc = src; // 接包方使用头像
      } else if (type == 2||type == 3||type == 4) {
        if (idp == 1) {
          imgsrc = outsourcerImg; // 接包方使用头像
        } else {
          imgsrc = awardingImg; // 发包方使用头像
        }
      }
      return imgsrc;
    },
    handleSelect(item){
      this.price=item.buyPrice
      this.isSelect=item.id
    },
    handleClose(){
      this.$emit('cancel')
    },
    handleClick(val){
      this.selected=val
    },
    handleSelectType(val){
      console.log(val)
      this.type=String(val)
    },
    handleJump(){
      this.$router.push("/privacy");
    },
    handleSure(){
      if(!this.checked){
        this.$message.warning('需同意并接受个人订阅服务协议')
        return
      }
      if(this.selected){
        this.$emit('sure',this.selected)
      }else{
        this.$message.warning('请选择任一支付方式')
      }

    },
  }
}
</script>
<style scoped>
.code-btn{
  cursor:pointer;
}
.payment{
  background:url("../../../assets/images/purchase/buy-bg.jpg") !important;
  background-size: 100% 100%;
  margin: 0 auto;
  width: 960px;
  flex-direction: column;
}
.content{
  display: flex;
}
.left{
  width: 690px;
  height: 680px;
  background: linear-gradient(91deg, rgba(104,186,253,0.48),rgba(102,0,255,0.48));
  border-radius: 22px 22px 0px 0px;
}
.head{
  display: flex;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 24px;
  align-items: center;
  margin-bottom: 28px;
  padding-left: 25px;
}
.left-head{
  display: flex;
  align-items: flex-end;
  height: 85px;
}
.selected-head{
  font-size: 27px;
  color: #673300;
  line-height: 102px;
  width: 295px;
  height: 69px;
  z-index:1;
  background:url('../../../assets/images/purchase/headBg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
  cursor: default;
  padding-bottom:28px
}
.three-selected{
  font-size: 27px;
  color: #673300;
  line-height: 102px;
  width: 323px;
  height: 65px;
  z-index:1;
  background:url('../../../assets/images/purchase/headBg2.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
  cursor: default;
  padding-bottom:28px;
  padding-right:10px;
  text-align: right;
}
.noselect-head{
  width: 250px;
  font-size: 20px;
  line-height: 24px;
  height: 57px;
  color: #FFFFFF;
}
.imgAvatar{
  border-radius: 50%;
}
.membership{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.box{
  width: 100%;
  background-color: #ffffff;
  padding:40px;

}
.title{
  font-size: 64px;
  font-weight: bold;
  margin-bottom: 28px;
}
.item{
  width: 160px;
  height: 160px;
  border:1px solid rgba(0, 0, 0, .12);
  border-radius: 16px;
  padding:20px;
  cursor: pointer;
}
.select{
  width: 160px;
  height: 160px;
  border-radius: 8px;
  padding:20px;
  background: linear-gradient(214deg, #ffe4a9, #fffdf0);
  border: 1px solid rgba(242, 148, 7, .64);
}
.name{
  font-size: 24px;
  font-weight: bold;
  margin-top:40px;
}
.price{
  font-size: 30px;
  font-weight: bold;
  margin-top:16px
}
.origin-price{
  text-decoration: line-through;
  font-size: 14px;
  color: #cccccc;
  margin-top:8px
}
.btn{
  margin-top:36px;
}
.payment-box{
  width: 668px;
  height: 60px;
  border:1px solid rgba(0, 0, 0, .12);
  border-radius: 16px;
  padding:8px;
  text-align: left;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.select-payment{
  width: 668px;
  height: 60px;
  border-radius: 8px;
  padding:8px;
  text-align: left;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  background: linear-gradient(214deg, #ffe4a9, #fffdf0);
  border: 1px solid rgba(242, 148, 7, .64);
}
.agreement{
  cursor:pointer;
}
.pay-price{
  font-weight: bold;
  font-size: 26px;
  text-align: right;
  margin-right: 20px;
  margin-bottom: 4px;
  color: rgba(242, 148, 7, 1)
}
.right{
  display: flex;
  flex-direction: column;
  color: #FFFFFF;
  width: 100%;
}
.right-title{
  font-weight: 900;
  font-size: 36px;
  color: #FFFFFF;
  line-height: 58px;
}
.right-sub{
  font-size: 28px;
  margin-bottom: 30px;
}
.right-item{
  margin-bottom: 12px;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  margin-left: 56px;
}
.two-selected{
  font-size: 27px;
  color: #673300;
  line-height: 102px;
  width: 537px;
  height: 65px;
  z-index:1;
  background:url('../../../assets/images/purchase/headBg3.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
  cursor: default;
  padding-bottom:28px
}
.two-selected-new{
  font-size: 27px;
  color: #673300;
  line-height: 102px;
  width: 537px;
  height: 65px;
  z-index:1;
  background:url('../../../assets/images/purchase/headBg4.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
  cursor: default;
  padding-bottom:28px
}
.three-selected-new{
  font-size: 27px;
  color: #673300;
  line-height: 102px;
  width: 442px;
  height: 65px;
  z-index:1;
  background:url('../../../assets/images/purchase/headBg5.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
  cursor: default;
  padding-bottom:28px;
  text-align: center;
}
.three-item{
  margin-bottom: 12px;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  margin-left: 49px;
}
.circle{
  width: 7px;
  height: 7px;
  background: #FFFFFF;
  border-radius: 50%;
  opacity: 0.6;
  margin-right: 10px;
}
.more-btn{
  width: 180px;
  height: 46px;
  border-radius: 10px;
  border: 1px solid #484848;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 24px;
  background:rgba(255,255,255,0.1);
  margin: 0 auto;


}
.right-text{
  font-size: 12px;
  color: #3F3F3F;
  line-height: 24px;
  opacity: 0.48;
  margin:20px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/accept/purchase-membership/payment.vue